import React, { useMemo, useState } from 'react'
import { Stack, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import TextFilter from 'components/TextFilter'
import MainContent, { TableContent } from 'components-shared'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'
import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import { ResponsiveTableProvider } from 'packages/ui/Table'
import useSubscribeRefresh from 'use-subscribe-actions'

import Table from './Table'

const IPTV = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [filters, setFilters] = useState({ verbatim: '' })
  const exportAction = useMemo(() => (
    <HeaderExportButton
      analyticsName="iptv"
      onClick={() => navigate({ pathname: `${location.pathname}/export` })}
    >
      {t('export.button')}
    </HeaderExportButton>
  ), [location.pathname, navigate, t])

  useRegisterBreadcrumbAction(exportAction)

  useSubscribeRefresh(() => navigate('/iptv'))

  return (
    <Stack sx={{ display: 'flex', flex: 1, gap: 2 }}>
      <Stack direction="row" justifyContent="space-between">
        <Box sx={{ width: '30%' }}>
          <TextFilter
            value={filters.verbatim || ''}
            placeholder={t('iptv.search.placeholder')}
            onChange={(newValue) => {
              setFilters(prev => ({...prev, verbatim: newValue}))
            }}
          />
        </Box>
      </Stack>
      <MainContent>
        <TableContent style={{ marginTop: 0 }}>
          <ResponsiveTableProvider>
            <Table filters={filters} />
          </ResponsiveTableProvider>
        </TableContent>
        <Outlet />
      </MainContent>
    </Stack>
  )
}

export default IPTV
